import React, { useEffect, useState } from "react";
import { Alert, Button, Modal, Snackbar } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CardEventAdmin from "../../../components/admin/card-event-admin/CardEventAdmin";
import {
  ICardEventAdmin,
  ICardEventAdminOnSumited,
  ICardEventAdminPost,
} from "../../../models/component/ICardEventAdmin";
import { useForm } from "react-hook-form";
import ChoiceBox from "../../../components/utils/box-choice/ChoiceBox";
import EventService from "../../../services/api/event.service";
import isEmpty from "../../../utils/isempty.utils";
import AuthService from "../../../services/api/auth.service";
import { IGallery } from "../../../models/component/IGallery";
import GalleryService from "../../../services/api/galerie.service";
import DisplayCalleryImage from "../../../components/admin/displayCalleryImage/DisplayCalleryImage";

const style = {
  position: "absolute",
  top: "30%",
  right: "10%",
  transform: "translate(-30%, -10%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const EventsAdmin = () => {
  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm<ICardEventAdminOnSumited>();

  const [open, setOpen] = useState(false);
  const [openFailed, setOpenFailed] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [displayGalerieForm, setDisplayGalerieForm] = useState(false);
  const [value, setValue] = useState(0);
  const [token, setToken] = useState<any>("");
  const [arrayCardEvent, setArrayCardEvent] = useState<ICardEventAdmin[]>([]);
  const [arrayGaleri, setArrayGaleri] = useState<IGallery>({ description: "", id: 0, images: [], name: "" });


  const handleCloseSnackbar = (event: any, reason: string) => {
    if (reason === "clickaway") return;
    setOpenFailed(false);
    setOpenSuccess(false);
  };

  const handleAddEvent = (value: ICardEventAdminPost, files: FileList) => {
    EventService.addEvent(value, files, token)
      .then((r) => {
        console.log(r.data);
        setMessage("Événement créé avec succès");
        setOpenSuccess(true);
        fetchAllEvents();
      })
      .catch((error) => {
        console.log(error)
        setMessage("Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer plus tard.");
        setOpenFailed(true);
        setTimeout(() => {
          setOpenFailed(false);
        }, 1000);
      });
  };

  const handleAddImageGallery = (files: FileList) => {
    GalleryService.addImages(files, token)
      .then((r) => {
        console.log(r.data);
        setMessage("Événement créé avec succès");
        setOpenSuccess(true);
        fetchAllElementsGaleri();
      })
      .catch((error) => {
        console.log(error)
        setMessage("Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer plus tard.");
        setOpenFailed(true);
        setTimeout(() => {
          setOpenFailed(false);
        }, 1000);
      });
  };



  const handleDeleteEvent = (id: number) => {
    EventService.remove(id, token)
      .then(() => {
        console.log("Événement supprimé, ID: " + id);
        setMessage("Événement et ses images supprimés avec succès");
        setOpenSuccess(true);
        fetchAllEvents();
      })
      .catch((error) => {
        console.log(error)
        setMessage("Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer plus tard.");
        setOpenFailed(true);
        setTimeout(() => {
          setOpenFailed(false);
        }, 1000);
      });
  };

  const handleDeleteElementGalery = (id: number) => {
    GalleryService.remove(id, token)
      .then(() => {
        console.log("Événement supprimé, ID: " + id);
        setMessage("Images supprimés avec succès");
        setOpenSuccess(true);
        fetchAllElementsGaleri()
      })
      .catch((error) => {
        console.log(error)
        setMessage("Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer plus tard.");
        setOpenFailed(true);
        setTimeout(() => {
          setOpenFailed(false);
        }, 1000);
      });
  };

  const fetchAllEvents = () => {
    EventService.getAllEvents()
      .then((r) => {
        if (!isEmpty(r.data)) {
          setArrayCardEvent(r.data);
        } else {
          setArrayCardEvent([]);
        }
      })
      .catch((error) => {
        console.log(error)
        setMessage("Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer plus tard.");
        setOpenFailed(true);
        setTimeout(() => {
          setOpenFailed(false);
        }, 1000);
      });
  };

  const fetchAllElementsGaleri = () => {
    GalleryService.getAll()
      .then((r) => {
        if (!isEmpty(r.data)) {
          setArrayGaleri(r.data);
        } else {
          setArrayGaleri({ description: "", id: 0, images: [], name: "" });
        }
      })
      .catch((error) => {
        console.log(error)
        setMessage("Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer plus tard.");
        setOpenFailed(true);
        setTimeout(() => {
          setOpenFailed(false);
        }, 1000);
      });
  };

  const onSubmit = handleSubmit((data) => {
    const file:FileList = data.images
    console.log(file)

    if (file.length > 3) {
      setError("images", {
        type: "manual",
        message: "Vous ne pouvez télécharger que 3 images maximum.",
      });
      return;
    }

    if (displayGalerieForm) {
      //Add Event
      handleAddEvent(data, file);
    } else {
      //ADD Image Galerie
      handleAddImageGallery(file);
    }
  });

  useEffect(() => {
    if (AuthService.getUserConnected() !== "" && AuthService.getUserConnected() !== null) {
      setToken(AuthService.getUserConnected());
      fetchAllEvents();
      fetchAllElementsGaleri();
    }
  }, [token]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleChoice = (choice: boolean) => {
    setDisplayGalerieForm(choice);
    console.log("Choix sélectionné :", choice);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="component-modal-event">
            <form onSubmit={onSubmit} className="container-form-event">
              <ChoiceBox option1={"Événement"} option2={"Galerie"} onChoice={handleChoice} />
              {
                displayGalerieForm ? (
                  <>
                    <input
                      className="input-form"
                      {...register("name", { required: "Le titre est obligatoire" })}
                      placeholder={"Titre"}
                      type="text"
                    />
                    <input
                      className="input-form"
                      {...register("description", { required: "La description est obligatoire" })}
                      placeholder={"Description"}
                      type="text"
                    />
                    <input
                      type="date"
                      {...register("date")}
                    />
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      {...register("images", {
                        validate: (files) => files.length <= 3 || "Vous ne pouvez télécharger que 3 images maximum.",
                      })}
                      onChange={() => clearErrors("images")}
                    />
                  </>
                ) : (
                  <>
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      {...register("images")}
                      onChange={() => clearErrors("images")}
                    />
                  </>
                )
              }

              {errors.images && <p style={{ color: "red" }}>{errors.images.message}</p>}
              <button type="submit">{displayGalerieForm ? "Ajouter à la Galerie" : "Créer l'Événement"}</button>
            </form>
          </div>
        </Box>
      </Modal>

      <div className="view-events-admin">
        <div className="header-events">
          <div className="header-event-title">Événements & Galeries</div>
          <Button
            variant="contained"
            onClick={() => setOpen(true)}
            sx={{ background: "rgb(34, 10, 110)", fontSize: 30 }}
          >
            {"+"}
          </Button>
        </div>
        <Box>
          <Tabs value={value} onChange={handleChange}>
            <Tab label="Événements" />
            <Tab label="Galeries" />
          </Tabs>
          <div role="tabpanel" hidden={value !== 0}>
            {arrayCardEvent.map((event, index) => (
              <CardEventAdmin
                key={index}
                name={event.name}
                description={event.description}
                date={event.date}
                images={event.images || []}
                id={event.id}
                onDelete={() => handleDeleteEvent(event.id)} // Ajout de la fonction de suppression
              />
            ))}
          </div>
          <div role="tabpanel" hidden={value !== 1}>
            <div className="display-all-gallery-img">
              {
                !isEmpty(arrayGaleri.images) ? (
                  arrayGaleri.images.map((value,index) =>
                    <DisplayCalleryImage key={index} image={value.uri} id={value.id} onDelete={handleDeleteElementGalery}/>
                  )
                ) : (
                  <div style={{position:"relative",left:"50%",top:"50px"}}>Aucune image</div>
                )
              }
            </div>
          </div>
        </Box>
        <Snackbar open={openSuccess} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert severity="success" sx={{ width: "100%" }}>
            {message}
          </Alert>
        </Snackbar>
        <Snackbar open={openFailed} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert severity="error" sx={{ width: "100%" }}>
            {message}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};

export default EventsAdmin;
